/**
 * Flash player enable - flash emulator swf — Ruffle-based Flash emulator
 *
 * Declares one WAR group, libs/ruffle/*.js and libs/ruffle/*.wasm, matched to every
 * http(s) origin with no use_dynamic_url. Most bundled files are build-hashed
 * (core.ruffle.<hash>.js, <hash>.wasm) and rotate per release, but the loader entry
 * libs/ruffle/ruffle.js keeps a stable vendor name, so a single fetch is conclusive.
 *
 * Manifest verified against version 1.3.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'ocfjjghignicohbjammlhhoeimpfnlhc';

export const flashPlayerEnable: ExtensionDefinition = {
  id: ID,
  name: 'Flash player enable - flash emulator swf',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 300_000,
  notes:
    'Exposes libs/ruffle to every origin with no dynamic URL. The wasm and core bundles ' +
    'are build-hashed, so detection uses the stable ruffle.js loader entry.',
  signals: [
    {
      id: 'war-ruffle-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch libs/ruffle/ruffle.js — the stable, vendor-named Ruffle loader exposed to ' +
        'every origin at a fixed URL. The other bundle names are build-hashed.',
      weight: 1,
      run: () => probeFetch(ID, 'libs/ruffle/ruffle.js'),
    },
  ],
};
